import axios from "axios";
import { FavoriteItemListModel, FavoriteItemSearchOptions } from "models";
import { IAPIResult } from "models/interfaces";

export async function search(options: FavoriteItemSearchOptions, withClone?:boolean) {
  // await Utils.sleep(300);

  const response = await axios.post<IAPIResult<FavoriteItemListModel>>(
    "/api.d/v1/ec/favorite-item/search",
    options
  );

  if (withClone && options.get_count) {
    while (response.data.data.favorite_item_list.length < options.get_count) {
      response.data.data.favorite_item_list.push({
        item_cd: "",
        favorite_item_cd: "",
        is_discretionary_price: false,
        item_main_image: {
          file_name: "",
          file_data: "",
          image_url: "",
        },
        item_name: "",
        sale_corp_id: "",
        sale_corp_name: "",
        sale_price: 0,
      });
    }
  }

  return response.data;
}

export async function add(favorite_item_cd: string): Promise<IAPIResult> {
  // await Utils.sleep(300);

  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/favorite-item/create",
    {
      favorite_item_cd,
    }
  );
  return response.data;
}

export async function del(favorite_item_cd: string) {
  // await Utils.sleep(300);

  const data = { favorite_item_cd };

  const response = await axios.delete<IAPIResult>(
    "/api.d/v1/ec/favorite-item/delete",
    { data }
  );
  return response.data;
}
